export { default } from "./SponsorVideo";
